/**
 * Firestore Collection and Document Path Constants
 * 
 * IMPORTANT: These paths must match exactly between frontend and backend.
 * Any mismatch will cause data inconsistencies and bugs.
 * 
 * When adding new paths:
 * 1. Add the constant here
 * 2. Use it in both frontend and backend
 * 3. Add a comment explaining what the path is for
 * 4. Update this file's JSDoc if needed
 */

/**
 * Workspace settings document ID
 * Stores: defaultCurrency, currencyOrder, timeFormat, permissions, etc.
 * Path: workspaces/{workspaceId}/settings/general
 * 
 * MUST MATCH: backend/src/utils/firestorePaths.ts::WORKSPACE_SETTINGS_DOC_ID
 */
export const WORKSPACE_SETTINGS_DOC_ID = "general";

/**
 * Helper function to get workspace settings document reference path
 * @param workspaceId - The workspace ID
 * @returns Array of path segments for Firestore doc() function
 */
export function getWorkspaceSettingsDocPath(workspaceId: string): [string, string, string, string] {
  return ["workspaces", workspaceId, "settings", WORKSPACE_SETTINGS_DOC_ID];
}
